export type TFaq = { question: string; answer: string };
type Data = Record<string, { category: string; data: TFaq[] }>;

export const FAQ: Data = {
  acesso: {
    category: 'Acesso',
    data: [
      {
        question: 'Como faço para acessar o app Angeplus pela primeira vez?',
        answer:
          'Primeiro, baixe o app através da loja virtual do seu celular. Depois, clique no ícone do app instalado no seu celular e, na tela inicial, escolha a opção “Criar conta” para fazer o cadastro inicial. A seguir, insira o seu e-mail e prossiga para a criação de senha. Lembre-se de inserir o seu e-mail de uso pessoal, e não o de terceiros. Observe atentamente as orientações sobre a criação de senha.',
      },

      {
        question: 'Estou tentando fazer login na conta e dá erro!',
        answer:
          'Certifique-se de que está escolhendo a opção certa: se você já fez o cadastro antes, acesse no app clicando na opção “Fazer Login”. Se ainda não fez, é necessária criar uma conta.',
      },
      {
        question: 'Como faço para alterar o meu e-mail de acesso?',
        answer:
          'A troca de e-mail deve ser solicitada através do Suporte Angelus, via WhatsApp, pelo 0800 006 6688.',
      },
    ],
  },
  'cuidados-e-saude': {
    category: 'Cuidados e Saúde',
    data: [
      {
        question: 'Como faço para agendar uma teleconsulta imediata?',
        answer:
          'Muito fácil! Acesse a sua conta no app ou site Angeplus e escolha a opção "Cuidados e Saúde". Em seguida, clique em "Teleconsulta Imediata" e depois em "Marcar Teleconsulta Imediata". Preencha as informações sobre seus sintomas. Se você tiver arquivos de exames e receitas médicas que podem ser úteis para a consulta, adicione no local indicado. Finalize o agendamento, clicando em “Marcar teleconsulta”. Minutos antes do atendimento da teleconsulta, você receberá um link de acesso pelo e-mail, WhatsApp ou SMS. Um clínico geral fará o seu atendimento.',
      },
      {
        question: 'E se eu precisar de um especialista?',
        answer:
          'Se o clínico geral achar necessário, ele mesmo fará o agendamento ou enviará um encaminhamento para que você possa agendar. Com o encaminhamento em mãos, basta ligar para a Central de Relacionamento, no 0800 006 6688 e agendar a consulta com o especialista. ',
      },
      {
        question:
          'Como faço para anexar exames ao meu prontuário na consulta de retorno?',
        answer:
          'Se precisar enviar exames ou documentos para sua consulta, entrar em contato com o 0800 006 6688 e nosso time irá auxiliá-lo.',
      },
      {
        question: 'Como sei se o meu plano dá direito ao uso de teleconsulta?',
        answer:
          'Se você tem um plano Bem Estar, Bem Seguro, Multiassistência ou adquiriu a taxa de teleconsulta, têm direito a consultas gratuitas ilimitadas. Se o seu plano é o Essencial, pode realizar até 5 consultas gratuitas com o clínico geral por mês.',
      },
      {
        question: 'Como encontrar médicos conveniados?',
        answer:
          'Em “Cuidados e Saúde”, selecione a opção “Guia médico (agendamentos)“. Na página principal, você poderá fazer a pesquisa por: médicos, dentistas, exames, procedimentos e outros profissionais.',
      },
      {
        question: 'Onde posso pesquisar as farmácias conveniadas?',
        answer: 'Acesse “Cuidados e Saúde” e selecione “Guia de Farmácia”.',
      },
    ],
  },
  mensalidades: {
    category: 'Mensalidades',
    data: [
      {
        question: 'Como faço para acompanhar meus pagamentos?',
        answer:
          'Acesse seu plano no aplicativo Angeplus, vá até a opção "Mensalidades" e você poderá conferir ou alterar a forma de pagamento, de acordo com as opções disponíveis no seu contrato.',
      },
      {
        question:
          'Quero alterar a forma de pagamento cartão de crédito recorrente para carnê!',
        answer:
          'Acesse o aplicativo Angeplus, escolha a opção "Mensalidade" e clique em "Opções de Pagamento". Por final, escolha a opção carnê, conforme as possibilidades disponíveis em seu contrato.',
      },
      {
        question:
          'Como posso alterar o cartão de crédito recorrente para outro cartão?',
        answer:
          'Acesse o aplicativo Angeplus, vá até a aba "Mensalidade", clique em "Opções de Pagamento" e selecione a opção de troca de cartão e insira os novos dados.',
      },
      {
        question:
          'O que fazer quando ocorre um erro ao alterar o cartão de crédito?',
        answer:
          'Verifique com a Central de Atendimento do seu cartão de crédito se o pagamento por recorrência está liberado e permitido mensalmente.',
      },
      {
        question: 'O que fazer em caso de cobrança indevida no meu cartão?',
        answer:
          'Entre em contato pelo WhatsApp no número 0800 006 6688 para verificar o ocorrido.',
      },
      {
        question:
          'Um dependente do plano consegue acessar e alterar a forma de pagamento?',
        answer:
          'Não. Somente o titular do contrato pode acessar o aplicativo, alterar a forma de pagamento ou gerar boletos.',
      },
    ],
  },
};
